import React from 'react';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import Slider from '@fiverr-private/slider/src';
import SafeComponent from '../shared/SafeComponent';
import { CLICKED_SUBCATEGORY_ARROW } from '../../utils/biEvents/events/mixPanelEvents';
import { LOHP_ROW } from '../../utils/constants';
import SubCategory from './SubCategory';
import { subCategories } from './config';

const SubcategoryCarousel = () => {
    const { isTouch } = getContext();
    const enrichedSubcategories = subCategories.map((subCategory) => ({ ...subCategory, isTouch }));

    return (
        <div className={classNames('subcategory-carousel', LOHP_ROW)}>
            <h2><I18n k="logged_out_homepage.subcategory_carousel.title"/></h2>
            <Slider freeScroll={isTouch}
                mixPanelEvent={CLICKED_SUBCATEGORY_ARROW}
                items={enrichedSubcategories}
                Component={SubCategory}/>
        </div>
    );
};

export { SubcategoryCarousel };
export default SafeComponent(SubcategoryCarousel);
